import { z } from 'zod';

export const profileSchema = z.object({
    first_name: z.string().min(1, 'El nombre es obligatorio'),
    last_name: z.string().min(1, 'El apellido es obligatorio'),
    phone_number: z.string().regex(/^\+?[0-9\s-]{8,}$/, 'Número de teléfono inválido').optional().or(z.literal('')),
    avatar: z.string().optional(),
});

export type ProfileFormValues = z.infer<typeof profileSchema>;
